<template>
  <div class="student-info-popover">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridDrawer :visible.sync="visible">
      <DialogLayout class="student-info-popover-layout"
                    :title="popoverTitle">
        <StudentInfoPanel :student-id="studentId"
                          :visible="visible"></StudentInfoPanel>
      </DialogLayout>
    </DataGridDrawer>
  </div>
</template>

<script>
import DataGridDrawer from '../../../../../../../elements/grid/DataGridDrawer'
import DialogLayout from '../../../../../../../widgets/DialogLayout'
import StudentInfoPanel from '../../../panel/student/info'
export default {
  name: 'StudentInfoPopover',
  components: {
    DataGridDrawer,
    DialogLayout,
    StudentInfoPanel
  },
  props: {
    popoverTitle: {
      type: String,
      default: '学生详细信息'
    },
    studentId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    }
  }
}
</script>

<style lang="scss">
  .student-info-popover {
    display: inline-block;
  }
  .student-info-popover-layout {
    max-width: 100%;
    width: 900px;
  }
</style>
